import TableCell from "../../../../table/TableCell"

class EditableCell extends TableCell {
    init(value, rowObj)
    {
        TableCell.call(this, value, rowObj);
        return this;
    }

    setEditorSelected()
    {
        this.renderer.setEditorSelected();
        this.renderer.updateUI(this);
    }

    unsetEditorSelected()
    {
        this.renderer.unsetEditorSelected();
        this.renderer.updateUI(this);
    }
}

export default EditableCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/EditableCell.js